const routerNamePrefix = 'official'
const documentTitle = '辅导老师招聘'

const router = [
  {
    path: 'delivery/:department',
    name: `${routerNamePrefix}_delivery`,
    component: () =>
      import(/* webpackChunkName: `${routerNamePrefix}_delivery` */ './Delivery.vue'),
    meta: {
      title: documentTitle,
    },
  },

  {
    path: 'delivery/:department/:status',
    name: `${routerNamePrefix}_result`,
    component: () => import('./Result.vue'),
  },

  {
    path: 'myProgress/:department',
    name: `${routerNamePrefix}_myProgress`,
    component: () =>
      import(/* webpackChunkName: `${routerNamePrefix}_myProgress` */ './myProgress/index.vue'),
  },
  {
    path: 'login',
    name: `${routerNamePrefix}_login`,
    component: () =>
      import(/* webpackChunkName: `${routerNamePrefix}_login` */ './login.vue'),
  },
]

export default router
export { routerNamePrefix }
